"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardContactUsTitle;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// components
function CardContactUsTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      inputs = _ref.inputs,
      buttonProps = _ref.buttonProps,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-auto p-5 lg:p-10"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-2xl font-semibold"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "leading-relaxed mt-1 mb-4 text-blueGray-500"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8"
  }, inputs.map(function (prop, key) {
    var textarea = prop.inputProps && prop.inputProps.type === "textarea";
    var inputProps = prop.inputProps ? prop.inputProps : {};
    var labelProps = prop.labelProps ? prop.labelProps : {};
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "relative w-full mb-3",
      key: key
    }, /*#__PURE__*/_react.default.createElement("label", _extends({}, labelProps, {
      className: "block uppercase text-blueGray-500 text-xs font-bold mb-2 ml-1"
    }), prop.labelText), textarea ? /*#__PURE__*/_react.default.createElement("textarea", _extends({}, inputProps, {
      className: "px-3 py-3 placeholder-blueGray-400 text-blueGray-500 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border-transparent"
    })) : /*#__PURE__*/_react.default.createElement("input", _extends({}, inputProps, {
      className: "px-3 py-3 placeholder-blueGray-400 text-blueGray-500 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 border-transparent"
    })));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center mt-6"
  }, /*#__PURE__*/_react.default.createElement("button", _extends({}, buttonProps, {
    className: "text-xs px-4 py-2 shadow hover:shadow-md text-white bg-blueGray-800 border-blueGray-800 active:bg-blueGray-900 active:border-blueGray-900 rounded outline-none focus:outline-none align-middle transition-all duration-150 ease-in-out uppercase border border-solid font-bold"
  }), buttonText)))));
}

CardContactUsTitle.defaultProps = {
  inputs: []
};
CardContactUsTitle.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  // for example you could pass an onClick handler like so:
  // buttonProps={{
  //   onClick: () => { alert("Check your console"); console.log("hey my dude"); }
  // }}
  buttonProps: _propTypes.default.object,
  // NOTE: you cannot change the default design of these components,
  // // // i.e. you cannot pass className as props for them
  inputs: _propTypes.default.arrayOf(_propTypes.default.shape({
    labelText: _propTypes.default.string,
    labelProps: _propTypes.default.object,
    // NOTE: if you wish to generate a textarea, you will need to pass
    // // // inside this object >> type: "textarea"
    // // // full example >> inputProps: { type: "textarea" }
    inputProps: _propTypes.default.object
  }))
};
